import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/shared/services/shared.service';
import { SideNavService } from 'src/app/shared/services/side-nav.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnDestroy, OnInit{
  @ViewChild('sidenav') sidenav: MatSidenav;
  opened: any = false;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
      if (event.target.innerWidth < 900) {
          this.sidenav.close();
          this.sidenav.opened=false;
          this.sharedService.showButton=true;
          this.sharedService.showButton2=true;
          this.sharedService.mobileSize=true;
      }else{
        this.sidenav.open();
        this.sidenav.opened=true
        this.sharedService.showButton=false
        this.sharedService.showButton2=false
        this.sharedService.mobileSize=false;
      }
  }
  public isShowSidebar: boolean;
  public mobileQuery: MediaQueryList;
  private mobileQueryListener: () => void;


  constructor(
    public sideNavService: SideNavService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public sharedService: SharedService,
    private router:Router) {
    this.mobileQuery = media.matchMedia('(max-width: 1024px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
    this.isShowSidebar = !this.mobileQuery.matches;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.sideNavService.setDrawer(this.sidenav);
      if(window.innerWidth< 900) {
        this.sidenav.close();
        this.sidenav.opened=false
        this.sharedService.showButton=true
        this.sharedService.mobileSize=true;
      }else{
        this.sidenav.open();
        this.sidenav.opened=true
        this.sharedService.showButton=false
        this.sharedService.mobileSize=false;
      }
    }, 500);
  }

  public toggleRightSidenav() {
    if(this.sidenav.opened){
      this.sidenav.close();
      this.sidenav.opened=false
      this.sharedService.showButton2=true
    }else{
      this.sidenav.open();
      this.sidenav.opened=true
      this.sharedService.showButton2=false
    }
	}

  public ngOnDestroy(): void {
    this.mobileQuery.removeListener(this.mobileQueryListener);
    this.sidenav.close();
  }

  public goLogin(): void{
    this.router.navigate(['login/lc'], { skipLocationChange: true });
  }
}
